import { Icon } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import React from 'react';
import useStyles from './styles';
export default function HeaderVideoButton() {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.videoBar
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    className: classes.videoButton,
    disableElevation: true
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "play"
  }), "See what we offer"));
}